import { subscribeUpscaleJob } from "@/upscaleJobs";
import UpscaleJobCard from "@/components/Upscales/UpscaleJobCard.vue";

/** Fertiger Job → Karte (wie in GenerateView); läuft der Job noch, rendert nichts */
export default {
  name: "UpscaleJobResult",
  components: { UpscaleJobCard },
  props: { jobId: { type: String, required: true } },
  data: () => ({ job: null, unsub: null }),
  watch: { jobId: { immediate: true, handler: "sub" } },
  beforeDestroy() {
    if (this.unsub) this.unsub();
  },
  methods: {
    sub() {
      if (this.unsub) this.unsub();
      this.unsub = subscribeUpscaleJob(this.jobId, (job) => (this.job = job));
    },
  },
  render(h) {
    if (!this.job || (this.job.status !== "done" && this.job.status !== "failed")) return null;
    return h(UpscaleJobCard, { props: { job: this.job }, class: "mt-2" });
  },
};
